import { render, staticRenderFns } from "./cell_name.vue?vue&type=template&id=67e8a818&scoped=true&"
import script from "./cell_name.vue?vue&type=script&lang=js&"
export * from "./cell_name.vue?vue&type=script&lang=js&"
import style0 from "./cell_name.vue?vue&type=style&index=0&id=67e8a818&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e8a818",
  null
  
)

export default component.exports